import { render, staticRenderFns } from "./OilChange.vue?vue&type=template&id=c5c1fd3e"
import script from "./OilChange.vue?vue&type=script&lang=js"
export * from "./OilChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports